import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Box } from '@mui/material';
import { RootState } from '../../state_data/reducer';
import PlatformAdminRoute from './PlatformAdminRoute';

interface PlatformAdminSuperRouteProps {
  children: ReactNode;
  nested?: boolean;
}

const PlatformAdminSuperRoute: React.FC<PlatformAdminSuperRouteProps> = ({ children, nested = false }) => {
  const platformAdminRole = useSelector((state: RootState) => state.auth.platformAdminRole);

  const content =
    platformAdminRole === 'super' ? (
      children
    ) : (
      <Box sx={{ p: 4, maxWidth: 480, mx: 'auto', mt: 8 }}>
        <Alert severity="error">
          This section is restricted to platform super admins.
        </Alert>
      </Box>
    );

  if (nested) return content;
  return <PlatformAdminRoute>{content}</PlatformAdminRoute>;
};

export default PlatformAdminSuperRoute;
